export default __webpack_public_path__ + "static/media/app-bar-save.0b131022.svg";